import { createSelector, createFeatureSelector } from '@ngrx/store';

import { CopyCropFieldsToManureSpaceState } from '../copy-cropfields-to-manure-space.models';

export const selectCopyCropFieldsToManureSpaceState =
  createFeatureSelector<CopyCropFieldsToManureSpaceState>('copyCropFieldsToManureSpace');

export const selectAmountCopying = createSelector(
  selectCopyCropFieldsToManureSpaceState,
  (state) => state?.amountOfCropFieldsCopying ?? 0,
);

export const selectAmountCompleted = createSelector(
  selectCopyCropFieldsToManureSpaceState,
  (state) => state?.amountOfCropFieldsCompleted ?? 0,
);

export const selectAmountTodo = createSelector(
  selectAmountCopying,
  selectAmountCompleted,
  (amountCopying, amountCompleted) => amountCopying - amountCompleted,
);

export const selectCopyProgress = createSelector(
  selectAmountCopying,
  selectAmountCompleted,
  (amountCopying, amountCompleted) => amountCompleted / amountCopying,
);

export const selectCopyPercentage = createSelector(
  selectCopyProgress,
  (progress) => progress * 100,
);

export const isCopying = createSelector(selectAmountTodo, (amountToCopy) => amountToCopy > 0);

export const isCopyDialogDismissed = createSelector(
  selectCopyCropFieldsToManureSpaceState,
  (state) => state?.copyDialogDismissed ?? false,
);

export const isCopyStatusDismissed = createSelector(
  selectCopyCropFieldsToManureSpaceState,
  (state) => state?.copyStatusDismissed ?? false,
);

export const showCopyStatus = createSelector(
  isCopyDialogDismissed,
  isCopyStatusDismissed,
  (copyDialogDismissed, copyStatusDismissed) => copyDialogDismissed && !copyStatusDismissed,
);
